var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[_c('div',{staticClass:"m-auto h-2/4 w-0 border-l-2 border-solid border-[#5B7185]",class:{}}),_vm._v(" "),_c('v-icon',{staticClass:"w-[24px] m-auto",staticStyle:{"display":"block"},attrs:{"color":_setup.disabled
          ? '#00000042'
          : _setup.item.finalSeverity && _setup.item.finalAssessmentReason
            ? 'success'
            : 'primary'}},[_vm._v("\n      "+_vm._s(_setup.item.finalSeverity && _setup.item.finalAssessmentReason
          ? 'mdi-check-circle'
          : 'mdi-circle')+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"m-auto h-2/4 w-0 border-l-2 border-solid border-[#5B7185]",class:{}})],1),_vm._v(" "),_c('td',[_vm._v("Severity")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_setup.item.scope &&
      _setup.item.scale &&
      _setup.item.type === _setup.EnumIroType.NegativeImpact &&
      _setup.item.irremediability
        ? parseFloat(
            ((_setup.item.scope + _setup.item.scale + _setup.item.irremediability) / 3).toFixed(2),
          )
        : _setup.item.scope && _setup.item.scale && _setup.item.type !== _setup.EnumIroType.NegativeImpact
          ? parseFloat(((_setup.item.scope + _setup.item.scale) / 2).toFixed(2))
          : '-')+"\n    "),(!_setup.editing)?_c('v-btn',{attrs:{"icon":"","small":"","disabled":_setup.disabled},on:{"click":() => {
          _setup.editing = !_setup.editing
        }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1):_vm._e(),_vm._v(" "),(
        _setup.item.scope ||
        _setup.item.scale ||
        (_setup.item.type === _setup.EnumIroType.NegativeImpact && _setup.item.irremediability) ||
        _setup.item.finalAssessmentReason
      )?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":() => {
          _setup.updateIRO({
            iro: {
              id: _setup.item.id,
              finalAssessmentReason: '',
              scope: null,
              scale: null,
              irremediability: null,
            },
          }).then(() => {
            _setup.editing = true
          })
        }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-reload")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('v-row',[(_setup.editing)?_c('span',{staticClass:"ml-4 mt-4"},[_vm._v("\n        "+_vm._s(_vm.$t('instruction'))+"\n      ")]):(!_setup.item.severity || !_setup.item.severityReason)?_c('span',{staticClass:"ml-4 mt-4"},[_vm._v("\n        "+_vm._s(_vm.$t('preAssNotFinished'))+"\n      ")]):_c('span',{staticClass:"ml-4 mt-4"},[_vm._v(_vm._s(_setup.item.finalAssessmentReason))])]),_vm._v(" "),(_setup.editing)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',{staticClass:"mb-0"},[_vm._v("Scope")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('ix-btn-toggle-scale5',{attrs:{"value":_setup.item.scope,"rounded":""},on:{"change":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  scope: val,
                },
              })
            }}})],1)],1):_vm._e(),_vm._v(" "),(_setup.editing)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',{staticClass:"mb-0"},[_vm._v("Scale")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('ix-btn-toggle-scale5',{attrs:{"value":_setup.item.scale,"rounded":""},on:{"change":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  scale: val,
                },
              })
            }}})],1)],1):_vm._e(),_vm._v(" "),(_setup.item.type === _setup.EnumIroType.NegativeImpact && _setup.editing)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',{staticClass:"mb-0"},[_vm._v("Irremediability")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('ix-btn-toggle-scale5',{attrs:{"value":_setup.item.irremediability,"rounded":""},on:{"change":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  irremediability: val,
                },
              })
            }}})],1)],1):_vm._e(),_vm._v(" "),(_setup.editing)?_c('v-row',[_c('v-col',{staticClass:"p-0",attrs:{"cols":"6"}},[_c('ix-form-input-text-master',{attrs:{"value":_setup.item.finalAssessmentReason,"title":_vm.$t('explainTitle'),"is-mandatory":true,"use-text-area":true},on:{"input":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  finalAssessmentReason: val,
                },
              })
            }}})],1),_vm._v(" "),_c('v-col',[_c('v-btn',{staticClass:"mt-[55px]",attrs:{"color":"primary","disabled":!(
              _setup.item.finalAssessmentReason &&
              _setup.item.scope &&
              _setup.item.scale &&
              (_setup.item.type === _setup.EnumIroType.NegativeImpact
                ? _setup.item.irremediability
                : true)
            )},on:{"click":() => {
              _setup.editing = false
            }}},[_vm._v("\n          "+_vm._s(_vm.$t('btnDone'))+"\n        ")])],1)],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }